import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as IconClose } from "../../build/images/closecircle22px.svg";
import { ReactComponent as CleanIcon } from "../../build/images/Clean.svg";
import { ReactComponent as CalendarIcon } from "../../build/images/calendar.svg";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  handleFilterManagerChannel,
  activeFiltersManager,
  clearFiltersManager,
  handleFilterManagerGroup,
  handleFilterManagerService,
  handleFilterManagerStatus,
  handleFilterManagerGroupRow,
  getServicesFilter,
  getRowGroupFilter,
  GetServiceGroupJson,
} from "../../actions";

let storageFilterGroup = localStorage.getItem("managernew_filter_group")
  ? localStorage.getItem("managernew_filter_group").split(",")
  : [];
let storageFilterStatus = localStorage.getItem("managernew_filter_status")
  ? localStorage.getItem("managernew_filter_status").split(",")
  : [];
let storageFilterService = localStorage.getItem("managernew_filter_service")
  ? localStorage.getItem("managernew_filter_service").split(",")
  : [];
let storageFilterChannel = localStorage.getItem("managernew_filter_channel")
  ? localStorage.getItem("managernew_filter_channel").split(",")
  : [];

storageFilterStatus = storageFilterStatus
  ? storageFilterStatus.map((storage) => parseInt(storage))
  : [];
storageFilterChannel = storageFilterChannel
  ? storageFilterChannel.map((storage) => parseInt(storage))
  : [];
storageFilterGroup = storageFilterGroup
  ? storageFilterGroup.map((storage) => parseInt(storage))
  : [];
storageFilterService = storageFilterService
  ? storageFilterService.map((storage) => parseInt(storage))
  : [];

let statusData = [
  {
    value: 1,
    label: "Livre",
    children: [],
  },
  {
    value: 2,
    label: "Em Interação",
    children: [],
  },
  {
    value: 3,
    label: "Pausado",
    children: [],
  },
  {
    value: 6,
    label: "AfterCallWork",
    children: [],
  },
  {
    value: 4,
    label: "Bloqueado",
    children: [],
  },
  {
    value: 5,
    label: "Inativo",
    children: [],
  },
];

let channelData = [
  {
    value: 1,
    label: "Voz",
    children: [],
  },
  {
    value: 2,
    label: "Webchat",
    children: [],
  },
  {
    value: 4,
    label: "Facebook",
    children: [],
  },
  {
    value: 5,
    label: "Whatsapp",
    children: [],
  },
  {
    value: 6,
    label: "Instagram",
    children: [],
  },
  {
    value: 8,
    label: "Telegram",
    children: [],
  },
  {
    value: 15,
    label: "Teams",
    children: [],
  },
];
let groupsPermission = [];

export default function Main({
  title = "Drawer Title",
  className = "",
  isOpen,
  onClose = () => null,
  headerContent,
  children,
  footerContent,
  setCloseDrawer,
  bind,
  screen,
}) {
  const userGroups = useSelector((state) => state.groups);
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor,
  );
  const serviceGroup = useSelector((state) => state.servicegroup);
  const servicoAgrupado = useSelector((state) => state.servicoagrupado);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const groupsRow = useSelector((state) => state.groupsrow);
  const InfoUsers = useSelector((state) => state.informationusers);

  const [isViewServices, setViewServices] = useState(false);
  const [isViewGroups, setViewGroups] = useState(false);
  const [isViewRows, setViewRows] = useState(false);
  const [isViewChannels, setViewChannels] = useState(false);
  const [isViewStatus, setViewStatus] = useState(false);
  const [groupsData, setGroupsData] = useState([]);
  const [groupsRowData, setGroupsRowData] = useState([]);
  const [textSearchGroup, setTextSearchGroup] = useState("");
  const [textSearchService, setTextSearchService] = useState("");
  const [textSearchGroupRow, setTextSearchGroupRow] = useState("");
  const [serviceData, setServiceData] = useState([]);
  const [canaisUserOptions, setCanaisUserOptions] = useState(() => {
    if (InfoUsers.user_midias) {
      return channelData.filter((canal) =>
        InfoUsers.user_midias.includes(canal.value),
      );
    }
    return channelData;
  });

  // const [serviceManager, setServiceManager] = useState(FiltersManager.filter_manager_service);
  // const [channelManager, setChannelManager] = useState(FiltersManager.filter_manager_channel);
  // const [statusManager, setStatusManager] = useState(FiltersManager.filter_manager_status);
  // const [serviceManager, setServiceManager] = useState([]);
  // const [serviceManager, setServiceManager] = useState([]);

  const dispatch = useDispatch();
  const drawerRef = useRef();

  const getInfoService = async () => {
    const responseService = await getServicesFilter();

    if (responseService.status === 200) {
      let serviceRefactored = [];
      let dataService = [...responseService.data];
      let arraySrvAgrupado = servicoAgrupado.servicoagrupado.map(
        (srv) => srv.idgrupo,
      );
      dataService = dataService.filter((filt) =>
        arraySrvAgrupado.includes(filt.idgrupo),
      );

      dataService.map((datum) => {
        serviceRefactored.push({
          value: datum.idgrupo,
          label: datum.nomegrupo,
          children: [],
        });
      });
      setServiceData(serviceRefactored);
    }
  };

  const getInfoRowGroups = async () => {
    const responseRowGroup = await getRowGroupFilter();

    if (responseRowGroup.status === 200) {
      let dataGroupsRow = [...responseRowGroup.data];
      let groupsRefactored = [];
      let optionsRow = [];

      dataGroupsRow.map((group) => {
        groupsRefactored.push({
          value: group.idgrupofila,
          label: group.nomegrupofila,
          children: [],
        });
        optionsRow.push(group.idgrupofila);
      });
      setGroupsRowData(groupsRefactored);
    }
  };

  const changeViewChannels = () => {
    setViewChannels(!isViewChannels);

    if (isViewGroups) setViewGroups(false);
    if (isViewStatus) setViewStatus(false);
    if (isViewServices) setViewServices(false);
    if (isViewRows) setViewRows(false);
  };

  const changeViewGroups = () => {
    setViewGroups(!isViewGroups);

    if (isViewChannels) setViewChannels(false);
    if (isViewStatus) setViewStatus(false);
    if (isViewServices) setViewServices(false);
    if (isViewRows) setViewRows(false);
  };

  const changeViewRows = () => {
    setViewRows(!isViewRows);

    if (isViewChannels) setViewChannels(false);
    if (isViewStatus) setViewStatus(false);
    if (isViewServices) setViewServices(false);
    if (isViewGroups) setViewGroups(false);
  };

  const changeViewService = () => {
    setViewServices(!isViewServices);

    if (isViewChannels) setViewChannels(false);
    if (isViewStatus) setViewStatus(false);
    if (isViewGroups) setViewGroups(false);
    if (isViewRows) setViewRows(false);
  };

  const changeViewStatus = () => {
    setViewStatus(!isViewStatus);

    if (isViewChannels) setViewChannels(false);
    if (isViewServices) setViewServices(false);
    if (isViewGroups) setViewGroups(false);
    if (isViewRows) setViewRows(false);
  };

  useEffect(() => {
    let serviceRefactored = [];
    if (servicoAgrupado.length !== 0) {
      // let jsonSRV = serviceData;
      // let arraySrvAgrupado = servicoAgrupado.servicoagrupado.map(
      //   (srv) => srv.idgrupo
      // );

      // jsonSRV = jsonSRV.filter((filt) =>
      //   arraySrvAgrupado.includes(filt.idgrupo)
      // );

      // jsonSRV.map((datum) => {
      //   serviceRefactored.push({
      //     value: datum.idgrupo,
      //     label: datum.nomegrupo,
      //     children: [],
      //   });
      // });
      // setServiceData(serviceRefactored);

      getInfoService();
    }
  }, [servicoAgrupado]);

  useEffect(() => {
    if (userGroups.length !== 0) {
      let groupsRefactored = [];

      if (GroupsPermissionSupervisor.length !== 0) {
        groupsPermission = GroupsPermissionSupervisor.map(
          (group) => group.usergroup,
        );
      }

      userGroups.groups.map((group) => {
        let isPermissionGroup = groupsPermission.filter(
          (todo) => group.id === todo,
        );
        if (isPermissionGroup.length !== 0) {
          groupsRefactored.push({
            value: group.id,
            label: group.name,
            children: [],
          });
        }
      });
      setGroupsData(groupsRefactored);
    }
  }, [userGroups, GroupsPermissionSupervisor]);

  // useEffect(() => {
  //   if (groupsRow.length !== 0) {
  //     let groupsRefactored = [];
  //     let optionsRow = [];

  //     groupsRow.map((group) => {
  //       groupsRefactored.push({
  //         value: group.idgrupofila,
  //         label: group.nomegrupofila,
  //         children: [],
  //       });
  //       optionsRow.push(group.idgrupofila);
  //     });
  //     setGroupsRowData(groupsRefactored);
  //     // dispatch(handleFilterManagerGroupRow(optionsRow));
  //   }
  // }, [groupsRow]);

  useEffect(() => {
    if (!isOpen) {
      setTextSearchService("");
      setTextSearchGroup("");
      setTextSearchGroupRow("");
    }
  }, [isOpen]);

  useEffect(() => {
    getInfoRowGroups();
  }, []);

  const filterGroup = (e, idgroup) => {
    let temp = FiltersManager.filter_manager_group;
    let checkAll = document.querySelector("input#checkbox-geral-all");
    if (e.target.checked) {
      temp = FiltersManager.filter_manager_group.concat([parseInt(idgroup)]);
    } else {
      temp = FiltersManager.filter_manager_group.filter(function (val) {
        return val != idgroup;
      });
    }
    dispatch(handleFilterManagerGroup(temp));
    if (temp.length !== groupDataFind.length && checkAll.checked) {
      checkAll.checked = false;
    } else if (temp.length === groupDataFind.length && !checkAll.checked) {
      checkAll.checked = true;
    }
  };

  const filterGroupRow = (e, idgroup) => {
    let temp = FiltersManager.filter_manager_grouprow;
    let checkAll = document.querySelector("input#checkbox-groupRow-all");
    if (e.target.checked) {
      temp = FiltersManager.filter_manager_grouprow.concat([parseInt(idgroup)]);
    } else {
      temp = FiltersManager.filter_manager_grouprow.filter(function (val) {
        return val != idgroup;
      });
    }
    dispatch(handleFilterManagerGroupRow(temp));
    if (temp.length !== groupRowDataFind.length && checkAll.checked) {
      checkAll.checked = false;
    } else if (temp.length === groupRowDataFind.length && !checkAll.checked) {
      checkAll.checked = true;
    }
  };

  const filterChannel = (e, idchannel) => {
    let temp = FiltersManager.filter_manager_channel;
    let checkAll = document.querySelector("input#checkbox-channel-all");
    if (e.target.checked) {
      temp = FiltersManager.filter_manager_channel.concat([
        parseInt(idchannel),
      ]);
    } else {
      temp = FiltersManager.filter_manager_channel.filter(function (val) {
        return val != idchannel;
      });
    }
    dispatch(handleFilterManagerChannel(temp));
    if (temp.length !== canaisUserOptions.length && checkAll.checked) {
      checkAll.checked = false;
    } else if (temp.length === canaisUserOptions.length && !checkAll.checked) {
      checkAll.checked = true;
    }
  };

  const filterStatus = (e, idstatus) => {
    let temp = FiltersManager.filter_manager_status;
    let checkAll = document.querySelector("input#checkbox-status-all");
    if (e.target.checked) {
      temp = FiltersManager.filter_manager_status.concat([parseInt(idstatus)]);
    } else {
      temp = FiltersManager.filter_manager_status.filter(function (val) {
        return val != idstatus;
      });
    }
    dispatch(handleFilterManagerStatus(temp));

    if (temp.length !== statusData.length && checkAll.checked) {
      checkAll.checked = false;
    } else if (temp.length === statusData.length && !checkAll.checked) {
      checkAll.checked = true;
    }
  };

  const filterService = (e, idservice) => {
    let temp = FiltersManager.filter_manager_service;
    let checkAll = document.querySelector("input#checkbox-service-all");
    if (e.target.checked) {
      temp = FiltersManager.filter_manager_service.concat([
        parseInt(idservice),
      ]);
    } else {
      temp = FiltersManager.filter_manager_service.filter(function (val) {
        return val != idservice;
      });
    }
    dispatch(handleFilterManagerService(temp));

    if (temp.length !== serviceDataFind.length && checkAll.checked) {
      checkAll.checked = false;
    } else if (temp.length === serviceDataFind.length && !checkAll.checked) {
      checkAll.checked = true;
    }
  };

  const handleCheckAll = (e, typeSelect) => {
    let temp = [];
    if (typeSelect === "service") {
      let services = serviceDataFind;
      if (e.target.checked) {
        services.forEach((group) => {
          temp.push(parseInt(group.value));
          let inputGet = document.querySelector(
            `input#checkbox-service${parseInt(group.value)}`,
          );
          if (inputGet && !inputGet.checked) {
            inputGet.checked = true;
          }
        });
      } else {
        services.forEach((group) => {
          let inputGet = document.querySelector(
            `input#checkbox-service${parseInt(group.value)}`,
          );
          if (inputGet && inputGet.checked) {
            inputGet.checked = false;
          }
        });
        temp = [];
      }
      dispatch(handleFilterManagerService(temp));
    } else if (typeSelect === "channel") {
      let channel = canaisUserOptions;
      if (e.target.checked) {
        channel.forEach((group) => {
          temp.push(parseInt(group.value));
          let inputGet = document.querySelector(
            `input#checkbox-channel${parseInt(group.value)}`,
          );
          if (inputGet && !inputGet.checked) {
            inputGet.checked = true;
          }
        });
      } else {
        channel.forEach((group) => {
          let inputGet = document.querySelector(
            `input#checkbox-channel${parseInt(group.value)}`,
          );
          if (inputGet && inputGet.checked) {
            inputGet.checked = false;
          }
        });
        temp = [];
      }
      dispatch(handleFilterManagerChannel(temp));
    } else if (typeSelect === "status") {
      let status = statusData;
      if (e.target.checked) {
        status.forEach((group) => {
          temp.push(parseInt(group.value));
          let inputGet = document.querySelector(
            `input#checkbox-status${parseInt(group.value)}`,
          );
          if (inputGet && !inputGet.checked) {
            inputGet.checked = true;
          }
        });
      } else {
        status.forEach((group) => {
          let inputGet = document.querySelector(
            `input#checkbox-status${parseInt(group.value)}`,
          );
          if (inputGet && inputGet.checked) {
            inputGet.checked = false;
          }
        });
        temp = [];
      }
      dispatch(handleFilterManagerStatus(temp));
    } else if (typeSelect === "groups") {
      let groups = groupDataFind;
      if (e.target.checked) {
        groups.forEach((group) => {
          temp.push(parseInt(group.value));
          let inputGet = document.querySelector(
            `input#checkbox-geral${parseInt(group.value)}`,
          );
          if (inputGet && !inputGet.checked) {
            inputGet.checked = true;
          }
        });
      } else {
        groups.forEach((group) => {
          let inputGet = document.querySelector(
            `input#checkbox-geral${parseInt(group.value)}`,
          );
          if (inputGet && inputGet.checked) {
            inputGet.checked = false;
          }
        });
        temp = [];
      }
      dispatch(handleFilterManagerGroup(temp));
    } else if (typeSelect === "grouprow") {
      let groupsRow = groupRowDataFind;
      if (e.target.checked) {
        groupsRow.forEach((group) => {
          temp.push(parseInt(group.value));
          let inputGet = document.querySelector(
            `input#checkbox-groupRow${parseInt(group.value)}`,
          );
          if (inputGet && !inputGet.checked) {
            inputGet.checked = true;
          }
        });
      } else {
        groupsRow.forEach((group) => {
          let inputGet = document.querySelector(
            `input#checkbox-groupRow${parseInt(group.value)}`,
          );
          if (inputGet && inputGet.checked) {
            inputGet.checked = false;
          }
        });
        temp = [];
      }
      dispatch(handleFilterManagerGroupRow(temp));
    }
  };

  const aplyFilterManager = () => {
    localStorage.setItem(
      "managernew_filter_service",
      FiltersManager.filter_manager_service,
    );
    dispatch(handleFilterManagerService(FiltersManager.filter_manager_service));

    dispatch(handleFilterManagerStatus(FiltersManager.filter_manager_status));
    localStorage.setItem(
      "managernew_filter_status",
      FiltersManager.filter_manager_status,
    );

    localStorage.setItem(
      "managernew_filter_channel",
      FiltersManager.filter_manager_channel,
    );
    dispatch(handleFilterManagerChannel(FiltersManager.filter_manager_channel));

    localStorage.setItem(
      "managernew_filter_group",
      FiltersManager.filter_manager_group,
    );
    dispatch(handleFilterManagerGroup(FiltersManager.filter_manager_group));

    localStorage.setItem(
      "managernew_filter_grouprow",
      FiltersManager.filter_manager_grouprow,
    );
    dispatch(
      handleFilterManagerGroupRow(FiltersManager.filter_manager_grouprow),
    );

    dispatch(activeFiltersManager());
    setCloseDrawer(bind);
  };

  const cleanFilters = () => {
    dispatch(clearFiltersManager());
    localStorage.removeItem(
      "managernew_filter_status",
      FiltersManager.filter_manager_service,
    );
    localStorage.removeItem(
      "managernew_filter_service",
      FiltersManager.filter_manager_status,
    );
    localStorage.removeItem(
      "managernew_filter_channel",
      FiltersManager.filter_manager_channel,
    );
    localStorage.removeItem(
      "managernew_filter_group",
      FiltersManager.filter_manager_group,
    );
    localStorage.removeItem(
      "managernew_filter_grouprow",
      FiltersManager.filter_manager_grouprow,
    );
    setCloseDrawer(bind);
  };

  let groupDataFind = groupsData || [];
  groupDataFind = _.filter(groupDataFind, (group) => {
    let arrayGroup = [group.label];
    return !_.isEmpty(textSearchGroup)
      ? arrayGroup
          .toString()
          .toLowerCase()
          .indexOf(textSearchGroup.toString().toLowerCase()) > -1
      : true;
  });

  let serviceDataFind = serviceData || [];
  serviceDataFind = _.filter(serviceDataFind, (service) => {
    let arrayService = [service.label];
    return !_.isEmpty(textSearchService)
      ? arrayService
          .toString()
          .toLowerCase()
          .indexOf(textSearchService.toString().toLowerCase()) > -1
      : true;
  });

  let groupRowDataFind = groupsRowData || [];
  groupRowDataFind = _.filter(groupRowDataFind, (group) => {
    let arrayGroup = [group.label];
    return !_.isEmpty(textSearchGroupRow)
      ? arrayGroup
          .toString()
          .toLowerCase()
          .indexOf(textSearchGroupRow.toString().toLowerCase()) > -1
      : true;
  });

  let reduced = [];
  let grupoAnterior = 0;

  serviceDataFind.map((service) => {
    if (service.value !== grupoAnterior) {
      grupoAnterior = service.value;
      reduced.push(service);
    }
  });

  serviceDataFind = reduced;

  if (isOpen) {
    return (
      <div className={`drawer ${isOpen ? "drawer-visible" : ""}`}>
        <div
          className={`drawer__div ${
            isOpen ? "drawer-div-visible" : ""
          } ${className}`}
          ref={drawerRef}
        >
          <header className="drawer__div__header">
            <div className="drawer__div__header__title">{title}</div>
            <div
              className="drawer__div__header__close"
              onClick={() => setCloseDrawer(bind)}
            >
              <IconClose />
            </div>
          </header>

          <div className="drawer__div__content">
            {screen === "manager" ? (
              <>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Serviços:
                  </span>
                  <div
                    className={
                      isViewServices
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={() => changeViewService()}
                    >
                      Selecione...
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__search-box">
                        <div className="full-search">
                          <input
                            type="text"
                            name="client-search"
                            id="client-search"
                            placeholder="Busca..."
                            onChange={(event) =>
                              setTextSearchService(event.target.value)
                            }
                          />
                          <button type="submit" className="full-search__btn">
                            <i className="material-icons">search</i>
                          </button>
                        </div>
                      </div>
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">
                              Serviços
                              <div className="checkbox-all">
                                <li className="checkbox__item-all">
                                  <input
                                    className="checkbox__list__input"
                                    id={"checkbox-service-all"}
                                    name={"checkbox-service-all"}
                                    type="checkbox"
                                    defaultChecked={
                                      FiltersManager.filter_manager_service
                                        .length === serviceDataFind.length
                                    }
                                    // value="Geral"
                                    onChange={(event) =>
                                      handleCheckAll(event, "service")
                                    }
                                  />
                                  <label htmlFor={"checkbox-service-all"}>
                                    {FiltersManager.filter_manager_service
                                      .length === serviceDataFind.length
                                      ? "Desmarcar Todos"
                                      : "Marcar Todos"}
                                  </label>
                                </li>
                              </div>
                            </div>
                            {serviceDataFind.map((service) => (
                              <li
                                className="checkbox__item"
                                key={service.value}
                              >
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-service" + service.value}
                                  name={"checkbox-service" + service.value}
                                  type="checkbox"
                                  defaultChecked={
                                    FiltersManager.filter_manager_service.findIndex(
                                      function (val) {
                                        return parseInt(val) === service.value;
                                      },
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  // value="Geral"
                                  onChange={(event) =>
                                    filterService(event, service.value)
                                  }
                                />
                                <label
                                  htmlFor={"checkbox-service" + service.value}
                                >
                                  {service.label}
                                </label>
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Canais:
                  </span>
                  <div
                    className={
                      isViewChannels
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={() => changeViewChannels()}
                    >
                      Selecione...
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">
                              Canais
                              <div className="checkbox-all">
                                <li className="checkbox__item-all">
                                  <input
                                    className="checkbox__list__input"
                                    id={"checkbox-channel-all"}
                                    name={"checkbox-channel-all"}
                                    type="checkbox"
                                    defaultChecked={
                                      FiltersManager.filter_manager_channel
                                        .length === canaisUserOptions.length
                                        ? true
                                        : false
                                    }
                                    // value="Geral"
                                    onChange={(event) =>
                                      handleCheckAll(event, "channel")
                                    }
                                  />
                                  <label htmlFor={"checkbox-channel-all"}>
                                    {FiltersManager.filter_manager_channel
                                      .length === canaisUserOptions.length
                                      ? "Desmarcar Todos"
                                      : "Marcar Todos"}
                                  </label>
                                </li>
                              </div>
                            </div>
                            {canaisUserOptions.map((channel) => (
                              <li
                                className="checkbox__item"
                                key={channel.value}
                              >
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-channel" + channel.value}
                                  name={"checkbox-channel" + channel.value}
                                  type="checkbox"
                                  defaultChecked={
                                    FiltersManager.filter_manager_channel.findIndex(
                                      function (val) {
                                        return parseInt(val) === channel.value;
                                      },
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  // value="Geral"
                                  onChange={(event) =>
                                    filterChannel(event, channel.value)
                                  }
                                />
                                <label
                                  htmlFor={"checkbox-channel" + channel.value}
                                >
                                  {channel.label}
                                </label>
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Status do Usuário:
                  </span>
                  <div
                    className={
                      isViewStatus
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={() => changeViewStatus()}
                    >
                      Selecione...
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">
                              Status{" "}
                              <div className="checkbox-all">
                                <li className="checkbox__item-all">
                                  <input
                                    className="checkbox__list__input"
                                    id={"checkbox-status-all"}
                                    name={"checkbox-status-all"}
                                    type="checkbox"
                                    defaultChecked={
                                      FiltersManager.filter_manager_status
                                        .length === statusData.length
                                        ? true
                                        : false
                                    }
                                    // value="Geral"
                                    onChange={(event) =>
                                      handleCheckAll(event, "status")
                                    }
                                  />
                                  <label htmlFor={"checkbox-status-all"}>
                                    {FiltersManager.filter_manager_status
                                      .length === statusData.length
                                      ? "Desmarcar Todos"
                                      : "Marcar Todos"}
                                  </label>
                                </li>
                              </div>
                            </div>
                            {statusData.map((status) => (
                              <li className="checkbox__item" key={status.value}>
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-status" + status.value}
                                  name={"checkbox-status" + status.value}
                                  type="checkbox"
                                  defaultChecked={
                                    FiltersManager.filter_manager_status.findIndex(
                                      function (val) {
                                        return parseInt(val) === status.value;
                                      },
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  value="Geral"
                                  onChange={(event) =>
                                    filterStatus(event, status.value)
                                  }
                                />
                                <label
                                  htmlFor={"checkbox-status" + status.value}
                                >
                                  {status.label}
                                </label>
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Grupo do Usuário:
                  </span>
                  <div
                    className={
                      isViewGroups
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={() => changeViewGroups()}
                    >
                      Selecione...
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__search-box">
                        <div className="full-search">
                          <input
                            type="text"
                            name="client-search"
                            id="client-search"
                            placeholder="Busca..."
                            onChange={(event) =>
                              setTextSearchGroup(event.target.value)
                            }
                          />
                          <button type="submit" className="full-search__btn">
                            <i className="material-icons">search</i>
                          </button>
                        </div>
                      </div>
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">
                              Grupos
                              <div className="checkbox-all">
                                <li className="checkbox__item-all">
                                  <input
                                    className="checkbox__list__input"
                                    id={"checkbox-geral-all"}
                                    name={"checkbox-geral-all"}
                                    type="checkbox"
                                    defaultChecked={
                                      FiltersManager.filter_manager_group
                                        .length === groupDataFind.length
                                        ? true
                                        : false
                                    }
                                    // value="Geral"
                                    onChange={(event) =>
                                      handleCheckAll(event, "groups")
                                    }
                                  />
                                  <label htmlFor={"checkbox-geral-all"}>
                                    {FiltersManager.filter_manager_group
                                      .length === groupDataFind.length
                                      ? "Desmarcar Todos"
                                      : "Marcar Todos"}
                                  </label>
                                </li>
                              </div>
                            </div>
                            {groupDataFind.map((group) => (
                              <li className="checkbox__item" key={group.value}>
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-geral" + group.value}
                                  name={"checkbox-geral" + group.value}
                                  type="checkbox"
                                  defaultChecked={
                                    FiltersManager.filter_manager_group.findIndex(
                                      function (val) {
                                        return parseInt(val) === group.value;
                                      },
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  value="Geral"
                                  onChange={(event) =>
                                    filterGroup(event, group.value)
                                  }
                                />
                                <label htmlFor={"checkbox-geral" + group.value}>
                                  {group.label}
                                </label>
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Grupo de Fila:
                  </span>
                  <div
                    className={
                      isViewRows
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={() => changeViewRows()}
                    >
                      Selecione...
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__search-box">
                        <div className="full-search">
                          <input
                            type="text"
                            name="client-search"
                            id="client-search"
                            placeholder="Busca..."
                            onChange={(event) =>
                              setTextSearchGroupRow(event.target.value)
                            }
                          />
                          <button type="submit" className="full-search__btn">
                            <i className="material-icons">search</i>
                          </button>
                        </div>
                      </div>
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">
                              Grupos
                              <div className="checkbox-all">
                                <li className="checkbox__item-all">
                                  <input
                                    className="checkbox__list__input"
                                    id={"checkbox-groupRow-all"}
                                    name={"checkbox-groupRow-all"}
                                    type="checkbox"
                                    defaultChecked={
                                      FiltersManager.filter_manager_grouprow
                                        .length === groupRowDataFind.length
                                        ? true
                                        : false
                                    }
                                    // value="Geral"
                                    onChange={(event) =>
                                      handleCheckAll(event, "grouprow")
                                    }
                                  />
                                  <label htmlFor={"checkbox-groupRow-all"}>
                                    {FiltersManager.filter_manager_grouprow
                                      .length === groupRowDataFind.length
                                      ? "Desmarcar Todos"
                                      : "Marcar Todos"}
                                  </label>
                                </li>
                              </div>
                            </div>
                            {groupRowDataFind.map((group) => (
                              <li className="checkbox__item" key={group.value}>
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-groupRow" + group.value}
                                  name={"checkbox-groupRow" + group.value}
                                  type="checkbox"
                                  defaultChecked={
                                    FiltersManager.filter_manager_grouprow.findIndex(
                                      function (val) {
                                        return parseInt(val) === group.value;
                                      },
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  value="Geral"
                                  onChange={(event) =>
                                    filterGroupRow(event, group.value)
                                  }
                                />
                                <label
                                  htmlFor={"checkbox-groupRow" + group.value}
                                >
                                  {group.label}
                                </label>
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">De:</span>
                  <input
                    type="text"
                    name="of"
                    className="drawer__div__content-box__input"
                  />
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">Para:</span>
                  <input
                    type="text"
                    name="of"
                    className="drawer__div__content-box__input"
                  />
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Assunto:
                  </span>
                  <input
                    type="text"
                    name="of"
                    className="drawer__div__content-box__input"
                  />
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Contém as Palavras:
                  </span>
                  <input
                    type="text"
                    name="of"
                    className="drawer__div__content-box__input"
                  />
                </div>
                <div className="drawer__div__content-box">
                  <span className="drawer__div__content-box__label">
                    Data entre:
                  </span>
                  <div className="drawer__div__content-box__container">
                    <input
                      type="text"
                      name="of"
                      className="drawer__div__content-box__input"
                    />
                    <div className="drawer__div__content-box__container-icon">
                      <CalendarIcon />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <footer className="drawer__div__footer">
            <button
              className="drawer__div__footer-btn-primary"
              onClick={() => cleanFilters()}
            >
              <CleanIcon />
              Limpar Filtros
            </button>
            <button
              className="drawer__div__footer-btn-secondary"
              onClick={() => aplyFilterManager()}
            >
              Aplicar Filtros
            </button>
          </footer>
        </div>
      </div>
    );
  } else {
    return "";
  }
}
